import React from 'react';
import EyeIconDetails from './EyeIconDetails';
import SyncResultDetailsDialog from './SyncResultDetailsDialog';

export default function SyncResultEyeIcon({ details, titleId }) {
  return (
    <EyeIconDetails
      DialogComponent={SyncResultDetailsDialog}
      dialogProps={{ details: details?.toJS ? details.toJS() : details, titleId }}
      ariaLabel='View details'
      style={{ marginLeft: '8px', color: '#3b8de0', cursor: 'pointer' }}
    />
  );
}
